import { useEffect, useState } from "react";
import { Type } from "lucide-react";

export function useLargePrint() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    document.documentElement.classList.toggle("large-print", on);
    return () => { document.documentElement.classList.remove("large-print"); };
  }, [on]);
  return [on, setOn];
}

export function LargePrintToggle({ lp, label }) {
  const [on, setOn] = lp;
  return (
    <button type="button" onClick={() => setOn(!on)} aria-pressed={on} data-testid="large-print-toggle"
      className={`shrink-0 h-12 px-3 rounded-lg border flex items-center gap-1.5 text-sm font-medium transition-colors ${on ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700"}`}>
      <Type className="w-5 h-5" aria-hidden="true" /><span className="sr-only sm:not-sr-only">{label}</span>
    </button>
  );
}
